export default __webpack_public_path__ + "static/media/export-as-png-container-story.890e3c03.png";